// import ReactGA from 'react-ga';
import ReactGA from "react-ga4";

export const initGA = (trackingID) => {
	ReactGA.initialize(trackingID);
};
export const gaSetUser = (user) => {
	ReactGA.set({ userId: user });
};

export const gaPageView = (location) => {
	const path = location.pathname + location.search
	ReactGA.send({ hitType: "pageview", page: path, title: path });
	// ReactGA.pageview(location.pathname + location.search);
};


/**
 * Event - Add custom tracking event.
 * @param {string} category 
 * @param {string} action 
 * @param {string} label 
 */
export const gaEvent = (category, action, label) => {
	ReactGA.event({
		category: category,
		action: action,
		label: label
	});
};

export const gaEventRequest = (api) => {
	// try { ReactGA.event("request_to", api); }
	try {
		ReactGA.event({
			category: api,
			action: 'request_to',
			label: api
		});
	}
	catch {}
	
}
